import moment from 'moment';

const VACATION_TYPE_KEYS = {
  0: 'vacation',
  1: 'unpaidVacation',
  2: 'maternityLeave',
  3: 'paternityLeave',
  4: 'parentalLeave',
  5: 'childSickLeave',
  6: 'careLeave',
  7: 'educationalLeave',
  8: 'timeCompensation',
};

export function buildAbsenceMap(data) {
  const map = {};
  if (!data) return map;

  (data.holidays || []).forEach((h) => {
    const date = moment(h.date || h).format('YYYY-MM-DD');
    map[date] = {
      type: 'holiday',
      isAccepted: true,
      isHalfDay: false,
      label: h.name,
    };
  });

  (data.vacations || []).forEach((v) => {
    const date = moment(v.date).format('YYYY-MM-DD');
    const typeKey = VACATION_TYPE_KEYS[v.type] || 'vacation';
    map[date] = {
      type: typeKey,
      isAccepted: Boolean(v.isAccepted),
      isHalfDay: Boolean(v.isHalfDay),
    };
  });

  (data.sickDays || []).forEach((s) => {
    const date = moment(s.date).format('YYYY-MM-DD');
    map[date] = {
      type: 'sick',
      isAccepted: true,
      isHalfDay: false,
    };
  });

  return map;
}
